export const formatCpfMasked = (cpf: string) => {
	if (!cpf) {
		return cpf;
	}

	const clean = cpf.replace(/\D/g, "");
	if (clean.length !== 11) {
		return cpf;
	}

	return `${clean.substring(0, 3)}.${clean.substring(3, 6)}.${clean.substring(6, 9)}-${clean.substring(9, 11)}`;
};
